<template>
    <v-list-item style="padding-left: 0">
        <v-list-item-icon style="margin-right: 0.5rem">
            <v-icon v-if="setting" color="green">mdi-check</v-icon>
            <v-icon v-else color="grey lighten-2">mdi-cancel</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                {{ label }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'MeetHeaderSetting',

    props: {
        setting: {
            type: Boolean,
            required: true,
        },

        label: {
            type: String,
            required: true,
        },
    },
};
</script>
